import { RESOURCE } from '@src/constants';
import api from './api';

const getFonts = async () => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.FONTS,
  });
  return response;
};

export { getFonts };
